import { render, staticRenderFns } from "./QualificationChangeActivationType.vue?vue&type=template&id=87924cba&"
import script from "./QualificationChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./QualificationChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports